import { render, staticRenderFns } from "./start-investing.vue?vue&type=template&id=676ca95b&scoped=true"
import script from "./start-investing.vue?vue&type=script&lang=js"
export * from "./start-investing.vue?vue&type=script&lang=js"
import style0 from "./start-investing.vue?vue&type=style&index=0&id=676ca95b&prod&scoped=true&lang=css"
import style1 from "./start-investing.vue?vue&type=style&index=1&id=676ca95b&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ca95b",
  null
  
)

export default component.exports